module.exports = __webpack_public_path__ + "static/media/Same.7bd0f40d.PNG";